

export class TariffPlanAddInput implements ITariffPlanAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId!: number;
    /** The auto-generated id of the state  master */
    stateId!: number;
    /** The provider name with 255 character limit */
    providerName!: string;
    /** The tariff plan with 255 character limit */
    tariffPlan!: string;
    /** The tariff plan validity days */
    validityDays!: number;
    /** The tariff plan data usage */
    dataUsageMb!: number;

    constructor(data?: ITariffPlanAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyDetailsId = _data["companyDetailsId"];
            this.stateId = _data["stateId"];
            this.providerName = _data["providerName"];
            this.tariffPlan = _data["tariffPlan"];
            this.validityDays = _data["validityDays"];
            this.dataUsageMb = _data["dataUsageMb"];
        }
    }

    static fromJS(data: any): TariffPlanAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new TariffPlanAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyDetailsId"] = this.companyDetailsId;
        data["stateId"] = this.stateId;
        data["providerName"] = this.providerName;
        data["tariffPlan"] = this.tariffPlan;
        data["validityDays"] = this.validityDays;
        data["dataUsageMb"] = this.dataUsageMb;
        return data; 
    }
}

export interface ITariffPlanAddInput {
    /** The auto-generated id of the company details master */
    companyDetailsId: number;
    /** The auto-generated id of the state  master */
    stateId: number;
    /** The provider name with 255 character limit */
    providerName: string;
    /** The tariff plan with 255 character limit */
    tariffPlan: string;
    /** The tariff plan validity days */
    validityDays: number;
    /** The tariff plan data usage */
    dataUsageMb: number;
}

